import { styled } from '@f8n-frontend/stitches';

import NftMedia from 'components/NftMedia';
import Box from 'components/base/Box';
import Modal from 'components/base/Modal';
import TwitterShareButtonLink from 'components/links/TwitterShareButtonLink';

import { LaunchMediaAsset } from 'types/media';

type BodyProps = {
  media: LaunchMediaAsset | null;
  description: string | React.ReactNode;
  title: string;
};

function Body(props: BodyProps) {
  const { media, description, title } = props;
  return (
    <Container>
      {media && <NftMedia media={media} />}
      <Box css={{ maxWidth: '360px' }}>
        <Modal.BodyTitle
          size={1}
          align="center"
          title={title}
          description={description}
        />
      </Box>
    </Container>
  );
}

const Container = styled('div', {
  gap: '$7',
  paddingX: '$4',
  paddingTop: '$6',
  paddingBottom: '$4',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
});

type FooterProps = {
  shareText?: string;
  extraCta?: React.ReactNode;
};

function Footer(props: FooterProps) {
  const { shareText, extraCta } = props;
  return (
    <Modal.Footer justify="stretch">
      {shareText && (
        <TwitterShareButtonLink twitterShareText={shareText} text="Share" />
      )}
      {extraCta}
    </Modal.Footer>
  );
}

const SuccessModal = {
  Body,
  Footer,
};

export default SuccessModal;
